import { useDispatch } from "react-redux";
import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpInputField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
import { Set_Driver_HeadObject_Set } from "../SliceDriver";
import { CmpCheckboxFieldV1, CmpDatePickerField001V1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function GCHead({
  //grid saleshistory end
  vRdxWmsHead,
  xKey,
  xErrorMsg,
  sAttribute,
}) {
  const dispatch = useDispatch();
  return (
    <form id="DriverHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0.9 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        marginTop={{xs:7, sm:0, md:0}}
      >
        <Grid item xs={12} sm={12} md={6}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            
            <Grid item xs={6} sm={3} md={6}>
              <CmpTextFieldV1
                 xLabelText="DriverCode"
                xValue={vRdxWmsHead.DriverCode}
                xType={"text"} // text/number/password
                xName={"DriverCode"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.DriverCode === "" ? false : true}
                xErrorMessage={xErrorMsg.DriverCode}
                xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={4.5} md={6}>
              <CmpTextFieldV1
               xLabelText="FirstName"
                xValue={vRdxWmsHead.FirstName}
                xType={"text"} // text/number/password
                xName={"FirstName"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      FirstName: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.FirstName === "" ? false : true}
                xErrorMessage={xErrorMsg.FirstName}
                xOnKeyUp={xKey}
              />
            </Grid>
            
            <Grid item xs={6} sm={4.5} md={6}>
               <CmpTextFieldV1
                  xLabelText="MiddleName"
                xValue={vRdxWmsHead.MiddleName}
                xType={"text"} // text/number/password
                xName={"MiddleName"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      MiddleName: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.MiddleName === "" ? false : true}
                xErrorMessage={xErrorMsg.MiddleName}
                xOnKeyUp={xKey}
              />
            </Grid>
            
            <Grid item xs={6} sm={3} md={6}>
              <CmpTextFieldV1
               xLabelText="LastName"
                xValue={vRdxWmsHead.LastName}
                xType={"text"} // text/number/password
                xName={"LastName"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      LastName: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.LastName === "" ? false : true}
                xErrorMessage={xErrorMsg.LastName}
                xOnKeyUp={xKey}
              />
            </Grid>

           
            <Grid item xs={6} sm={3} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Location"
                xValue={vRdxWmsHead.Location}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      Location: e.target.value,
                    })
                  );
                }}
                xName={"Location"}
                xData={sAttribute?.Location}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Location === "" ? false : true}
                xErrorMessage={xErrorMsg.Location}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
          
            <Grid item xs={6} sm={3} md={6}>
              <CmpDatePickerField001V1
                xtabIndex={"4"}
                xLabelText="DOB"
                xValue={vRdxWmsHead.DOB}
                xOnChange={(e) => {
                  if (
                    e?.$d == "Invalid Date" ||
                    e?.$d == null ||
                    e?.$d === undefined ||
                    e?.$d === ""
                  ) {
                    dispatch(
                      Set_Driver_HeadObject_Set({
                        ...vRdxWmsHead,
                        A_ReceiptDt: "",
                      })
                    );
                  } else {
                    dispatch(
                      Set_Driver_HeadObject_Set({
                        ...vRdxWmsHead,
                        A_ReceiptDt: e?.$d,
                      })
                    );
                  }
                }}
                xName={"DOB"}
                xError={xErrorMsg.DOB === "" ? false : true}
                xErrorMessage={xErrorMsg.DOB}

                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
             
            <Grid item xs={6} sm={3} md={6}>
              <CmpTextFieldV1
               xLabelText="LastName"
                xValue={vRdxWmsHead.FullName}
                xType={"text"} // text/number/password
                xName={"FullName"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      FullName: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.FullName === "" ? false : true}
                xErrorMessage={xErrorMsg.FullName}
                xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            
            <Grid item xs={6} sm={3} md={6}>
             <CmpTextFieldV1
               xLabelText="LicenseNo"
                xValue={vRdxWmsHead.LicenseNo}
                xType={"text"} // text/number/password
                xName={"LicenseNo"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      LicenseNo: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.LicenseNo === "" ? false : true}
                xErrorMessage={xErrorMsg.LicenseNo}
                xOnKeyUp={xKey}
              />
            </Grid>
          
            <Grid item xs={6} sm={3} md={6}>
              <CmpDatePickerField001V1
               xLabelText="IssueDate"
                xtabIndex={"4"}
                xValue={vRdxWmsHead.IssueDate}
                xOnChange={(e) => {
                  if (
                    e?.$d == "Invalid Date" ||
                    e?.$d == null ||
                    e?.$d === undefined ||
                    e?.$d === ""
                  ) {
                    dispatch(
                      Set_Driver_HeadObject_Set({
                        ...vRdxWmsHead,
                        IssueDate: "",
                      })
                    );
                  } else {
                    dispatch(
                      Set_Driver_HeadObject_Set({
                        ...vRdxWmsHead,
                        IssueDate: e?.$d,
                      })
                    );
                  }
                }}
                xName={"IssueDate"}
                xError={xErrorMsg.IssueDate === "" ? false : true}
                xErrorMessage={xErrorMsg.IssueDate}

                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
             
            <Grid item xs={6} sm={3} md={6}>
              <CmpDatePickerField001V1
                  xLabelText="ExpiryDate"
                xtabIndex={"4"}
                xValue={vRdxWmsHead.ExpiryDate}
                xmindate={vRdxWmsHead.IssueDate}
                xOnChange={(e) => {
                  if (
                    e?.$d == "Invalid Date" ||
                    e?.$d == null ||
                    e?.$d === undefined ||
                    e?.$d === ""
                  ) {
                    dispatch(
                      Set_Driver_HeadObject_Set({
                        ...vRdxWmsHead,
                        ExpiryDate: "",
                      })
                    );
                  } else {
                    dispatch(
                      Set_Driver_HeadObject_Set({
                        ...vRdxWmsHead,
                        ExpiryDate: e?.$d,
                      })
                    );
                  }
                }}
                xName={"ExpiryDate"}
                xError={xErrorMsg.ExpiryDate === "" ? false : true}
                xErrorMessage={xErrorMsg.ExpiryDate}

                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
           
            <Grid item xs={6} sm={3} md={6}>
              <CmpSelectFieldV1
              
                xtabIndex={"1"}
                xLabelText="LicenseType"
                xValue={vRdxWmsHead.LicenseType}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      LicenseType: e.target.value,
                    })
                  );
                }}
                xName={"LicenseType"}
                xData={sAttribute?.LicenseType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.LicenseType === "" ? false : true}
                xErrorMessage={xErrorMsg.LicenseType}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>

           
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Type"
                xValue={vRdxWmsHead.Type}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      Type: e.target.value,
                    })
                  );
                }}
                xName={"Type"}
                xData={sAttribute?.Type}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Type === "" ? false : true}
                xErrorMessage={xErrorMsg.Type}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
             
            <Grid item xs={6} sm={4} md={2}>
              <CmpCheckboxField
                xtabIndex={"107"}
                xChecked={vRdxWmsHead?.InActive === "Y"}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      InActive: e.target.checked ? "Y" : "N",
                    })
                  );
                }}
                xDisabled={false}
                xName={"InActive"}
                xNameField={"InActive"}
                xError={xErrorMsg.InActive === "" ? false : true}
                xErrorMessage={xErrorMsg.InActive}
              />
            </Grid>
            
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Nationality"
                xValue={vRdxWmsHead.Nationality}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      Nationality: e.target.value,
                    })
                  );
                }}
                xName={"Nationality"}
                xData={sAttribute?.Nationality}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Nationality === "" ? false : true}
                xErrorMessage={xErrorMsg.Nationality}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={5} md={6}>
               <CmpTextFieldV1
                xLabelText="SMSName"
                xValue={vRdxWmsHead.SMSName}
                xType={"text"} // text/number/password
                xName={"SMSName"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      SMSName: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.SMSName === "" ? false : true}
                xErrorMessage={xErrorMsg.SMSName}
                xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={4} md={6}>
                <CmpTextFieldV1
                xLabelText="ContactNo"
                xValue={vRdxWmsHead.ContactNo}
                xType={"text"} // text/number/password
                xName={"ContactNo"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      ContactNo: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.ContactNo === "" ? false : true}
                xErrorMessage={xErrorMsg.ContactNo}
                xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={3} md={2}>
              <CmpCheckboxField
                xtabIndex={"108"}
                xChecked={vRdxWmsHead?.WMS === "Y"}
                xOnChange={(e) => {
                  dispatch(
                    Set_Driver_HeadObject_Set({
                      ...vRdxWmsHead,
                      WMS: e.target.checked ? "Y" : "N",
                    })
                  );
                }}
                xDisabled={false}
                xName={"WMS"}
                xNameField={"WMS"}
                xError={xErrorMsg.WMS === "" ? false : true}
                xErrorMessage={xErrorMsg.WMS}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
